/**
 * Prepares avatar by joining s3 bucket url and file name
 * @param bucketURL s3 bucket url
 * @param fileName file name
 */
export function getAvatarURL(bucketURL: BucketURL, fileName: string) {
  return `https://${bucketURL}${fileName}`;
}
